// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"Thumbnail_thumbnail__Gon77"};